import { useEffect } from 'react'
import { isWeb } from 'tamagui'
import { IProductPaymentOption } from '@dtos/ProductPage'

// Porta o snippets/school/product/trackings.liquid: injeta GA4, Google Ads e
// Facebook Pixel a partir dos IDs configurados na payment option. Web-only e
// guardado contra dupla injeção (refetches do Apollo).
let injected = false

const injectScript = (src: string) => {
  const script = document.createElement('script')
  script.async = true
  script.src = src
  document.head.appendChild(script)
}

const injectInline = (code: string) => {
  const script = document.createElement('script')
  script.text = code
  document.head.appendChild(script)
}

export function TrackingScripts({
  option,
}: {
  option: IProductPaymentOption | null
}) {
  useEffect(() => {
    if (!isWeb || !option || injected) return

    const { gaTrackingId, googleAdsTrackingId, facebookPixel } = option
    if (!gaTrackingId && !googleAdsTrackingId && !facebookPixel) return

    injected = true

    const gtagId = gaTrackingId || googleAdsTrackingId
    if (gtagId) {
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${gtagId}`)
      const configs = [gaTrackingId, googleAdsTrackingId]
        .filter(Boolean)
        .map((id) => `gtag('config', '${id}');`)
        .join('\n')
      injectInline(
        `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
${configs}`,
      )
    }

    if (facebookPixel) {
      injectInline(
        `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
document,'script','https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${facebookPixel}');
fbq('track', 'PageView');`,
      )
    }
  }, [option])

  return null
}
